import type {UseQueryResult} from '@github-ui/react-query'
import type {PropsWithChildren} from 'react'

import type {FetchRepositoriesData, PickerRepository} from '../types'

export function ListMessage({children}: PropsWithChildren) {
  return <div className="m-6 p-6 text-center">{children}</div>
}

export function getBlankMessage(
  {isLoading, isError}: UseQueryResult<FetchRepositoriesData>,
  visibleItems: PickerRepository[],
): string {
  if (isLoading) {
    return 'Loading repositories...'
  }

  if (isError) {
    return 'Error loading repositories.'
  }

  if (visibleItems.length === 0) {
    return 'No repositories to show.'
  }

  return ''
}

export function getResultsAnnouncement({
  blankMessage,
  itemsCount,
  totalItemsCount,
}: {
  blankMessage: string
  itemsCount: number
  totalItemsCount: number
}) {
  if (blankMessage) {
    return blankMessage
  }
  if (itemsCount >= totalItemsCount) {
    return `${itemsCount} ${itemsCount === 1 ? 'repository' : 'repositories'} matching`
  }
  if (itemsCount > 0) {
    return `${totalItemsCount} repositories matching, showing first ${itemsCount}`
  }
}

try{ ListMessage.displayName ||= 'ListMessage' } catch {}